import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  VerificationModal as VerificationModalLightbox,
  useApplicationNotifications,
} from '@adc/ui-adc'
import {
  VERIFICATION_MODAL_SUCCESS_TITLE,
  VERIFICATION_MODAL_FAIL_TITLE,
  VERIFICATION_MODAL_FAIL_BODY,
} from '../statics'

const { actions: verificationModalActions } = VerificationModalLightbox

const VerificationModal = ({
  emailAddress,
  verificationModalOpen,
  processVerification,
  closeVerification,
  failVerification,
}) => {
  const notifications = useApplicationNotifications()
  return (
    <div>
      <VerificationModalLightbox
        email={emailAddress}
        isOpen={verificationModalOpen}
        onClose={closeVerification}
        onSuccess={() => {
          processVerification()
          notifications.overlayBanner.open({
            title: VERIFICATION_MODAL_SUCCESS_TITLE,
          })
        }}
        onFail={() => {
          failVerification()
          notifications.overlayBanner.open({
            role: 'error',
            title: VERIFICATION_MODAL_FAIL_TITLE,
            message: VERIFICATION_MODAL_FAIL_BODY,
          })
        }}
      />
    </div>
  )
}

VerificationModal.propTypes = {
  emailAddress: PropTypes.string.isRequired,
  verificationModalOpen: PropTypes.bool.isRequired,
  processVerification: PropTypes.func.isRequired,
  closeVerification: PropTypes.func.isRequired,
  failVerification: PropTypes.func.isRequired,
}

const mapStateToProps = store => ({
  emailAddress: store.user.email_address,
  verificationModalOpen: store.verificationModalReducer.modalOpen,
})

const mapDispatchToProps = dispatch => ({
  processVerification: () => {
    dispatch(verificationModalActions.hideVerificationModal())
    dispatch(verificationModalActions.processPostVerificationQueue())
  },
  failVerification: () => {
    dispatch(verificationModalActions.hideVerificationModal())
    dispatch(verificationModalActions.clearVerificationQueue())
  },
  closeVerification: () => {
    dispatch(verificationModalActions.hideVerificationModal())
    dispatch(verificationModalActions.clearVerificationQueue())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(VerificationModal)
